import { Component, HostBinding } from '@angular/core';
import { ScreenService, AppInfoService } from './shared/services';
import { LookupService } from './services/Lookup/lookup.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  constructor(private screen: ScreenService, public appInfo: AppInfoService, public lookupService: LookupService, private router: Router) {

    // window.addEventListener('storage', this.handleStorageChange.bind(this));

  }

  check: string;

  // handleStorageChange(event) {
  //   const removedKeys = [
  //     'currentProvider',
  //     'clemittanceTokenKey',
  //     'isAuthorized',
  //     'UserRole',
  //     'loggedUsername',
  //     'reloadPage',
  //     'ProviderToken',
  //     'ProviderCurrentUsername',
  //     'currentSessionTokenKey'
  //   ];
  //   if (removedKeys.includes(event.key)) {
  //     localStorage.removeItem('UserRole');
  //     localStorage.removeItem('reloadPage');
  //     localStorage.removeItem('isAuthorized');
  //     localStorage.removeItem('ProviderToken');
  //     localStorage.removeItem('currentSessionTokenKey');
  //     localStorage.removeItem('loggedUsername');
  //     localStorage.removeItem('ProviderCurrentUsername');
  //     localStorage.removeItem('currentProvider');
  //     this.router.navigate(['/login-form']);
  //   }
  // }
  isAuthorized() {
    this.check = localStorage.getItem("isAuthorized");
    if (this.check == "true") return true;
    else return false;
  }
}